import config from '../../../config/config';
import getRequest from '../base/get';
import postRequest from '../base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Create the user api call function
   * @param {any} data data
   * @returns {any} promise
   */
  remoteStopTransaction: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(
      `${config.emsp.emspApiUrl}api/v2/commercial-charging-transaction/remote-stop-transaction`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Accounts list with pagination
   * @param {any} query - The query
   */
  fetchCommercialSessionList: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.emsp.sessionsApiUrl}api/emsp/v2/commercial-charging-transaction`, {
      ...parameters,
    });
  },

  /**
   * Fetch the Accounts list with pagination
   */
  fetchCommercialListFilters: () => {
    return getRequest(
      `${config.emsp.sessionsApiUrl}api/emsp/v2/commercial-charging-transaction/list-filters`,
    );
  },

  /**
   * Fetch commercial sessions API for export
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the exported data
   */
  fetchCommercialSessionExport: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.emsp.sessionsApiUrl}api/emsp/v2/commercial-charging-transaction/export`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Accounts list with pagination version 2
   * @param {any} query - The query
   */
  fetchPersonalSessionList: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.emsp.sessionsApiUrl}api/emsp/v1/personal-charging-transaction`, {
      ...parameters,
    });
  },
  /**
   * Fetch a single commercial session details by its session ID
   * @param {string} sessionId - The session ID
   * @returns {Promise<any>} A promise that resolves to the session details API response
   */
  fetchCommercialSessionById: (sessionId: string): Promise<any> => {
    return getRequest(
      `${config.emsp.sessionsApiUrl}api/emsp/v2/commercial-charging-transaction/${sessionId}`,
    );
  },
  /**
   * Fetch personal sessions API for export
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the exported data
   */
  fetchPersonalSessionExport: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.emsp.sessionsApiUrl}api/emsp/v1/personal-charging-transaction/export`, {
      ...parameters,
    });
  },


  /**
   * Fetch the Accounts list with pagination
   * @param {any} query - The query
   * @returns {Promise<any>} A promise that resolves to the commercial session vehicle list
   */
  fetchCommercialSessionVehicalList: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.emsp.sessionsApiUrl}api/emsp/v2/commercial-charging-transaction`, {
      ...parameters,
    });
  },
  /**
   * Fetch session count for vehicles
   * @param {string[] | { vehicleId?: string[]; 'vehicleId[]'?: string[] }} vehicleIds - Array of vehicle IDs or query object
   * @returns {Promise<any>} A promise that resolves to the vehicles session count response
   */
  fetchVehiclesSessionCount: (
    vehicleIds: string[] | { vehicleId?: string[]; 'vehicleId[]'?: string[] },
  ): Promise<any> => {
    let ids: string[] = [];
    if (Array.isArray(vehicleIds)) {
      ids = vehicleIds;
    } else if (vehicleIds && Array.isArray(vehicleIds.vehicleId)) {
      ids = vehicleIds.vehicleId;
    } else if (vehicleIds && Array.isArray(vehicleIds['vehicleId[]'])) {
      ids = vehicleIds['vehicleId[]'];
    }
    const query = ids.map((id) => `vehicleId[]=${encodeURIComponent(id)}`).join('&');
    return getRequest(
      `${config.emsp.sessionsApiUrl}api/emsp/v2/commercial-charging-transaction/vehicles-session-count${
        query ? `?${query}` : ''
      }`,
    );
  },
};
